import { useHistory } from 'react-router-dom';
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonLabel, IonNote, IonChip } from '@ionic/react';
import { briefcase } from 'ionicons/icons';
import { useSuggestedJobs } from '@/lib/mock/hooks';
import { NoindexSeo } from '@/components/NoindexSeo';

export function MatchSuggestions({ candidateSlug }: { candidateSlug: string }) {
  const history = useHistory();
  const { data: matches, isLoading } = useSuggestedJobs(candidateSlug);

  if (isLoading) return null;
  if (!matches || matches.length === 0) {
    return (
      <IonCard>
        <IonCardContent>
          <p className="bp-subheading">No matching jobs yet — update your skills and preferences to get matched.</p>
        </IonCardContent>
      </IonCard>
    );
  }

  return (
    <IonCard>
      <NoindexSeo />
      <IonCardHeader>
        <IonCardTitle style={{ color: '#f1f5f9' }}>Suggested Jobs</IonCardTitle>
      </IonCardHeader>
      <IonCardContent style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {matches.map((m) => (
          <MatchRow
            key={m._id}
            jobId={m.jobListing.id}
            score={m.matchScore ?? 0}
            reason={m.matchReason ?? ''}
            onOpen={() => history.push(`/jobs/${m.jobListing.id}`)}
          />
        ))}
      </IonCardContent>
    </IonCard>
  );
}

function MatchRow({ jobId, score, reason, onOpen }: { jobId: string; score: number; reason: string; onOpen: () => void }) {
  return (
    <div
      onClick={onOpen}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: 10,
        border: '1px solid var(--ion-color-step-150)',
        borderRadius: 10,
        cursor: 'pointer',
      }}
    >
      <div
        style={{
          minWidth: 44,
          height: 44,
          borderRadius: 10,
          background: 'rgba(59,130,246,0.15)',
          color: 'var(--bp-blue-400)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IonIcon icon={briefcase} style={{ fontSize: '1.2rem' }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: '0.85rem' }}>{jobId}</div>
        <IonNote style={{ fontSize: '0.72rem' }}>{reason}</IonNote>
      </div>
      <IonChip color="primary" style={{ height: 22 }}>
        <IonLabel>{score}% match</IonLabel>
      </IonChip>
    </div>
  );
}
